import React, { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & {
  secondaryfill?: string;
  strokewidth?: number;
  title?: string;
};

function DuplicatePlus({
  strokewidth: _strokewidth = 1,
  width = "1em",
  height = "1em",
  ...props
}: IconProps) {
  return (
    <svg
      height={height}
      width={width}
      {...props}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor">
        <path
          d="M13.75 4.5H7.25C5.7334 4.5 4.5 5.7334 4.5 7.25V13.75C4.5 15.2666 5.7334 16.5 7.25 16.5H13.75C15.2666 16.5 16.5 15.2666 16.5 13.75V7.25C16.5 5.7334 15.2666 4.5 13.75 4.5ZM12.75 11.25H11.25V12.75C11.25 13.1641 10.9141 13.5 10.5 13.5C10.0859 13.5 9.75 13.1641 9.75 12.75V11.25H8.25C7.8359 11.25 7.5 10.9141 7.5 10.5C7.5 10.0859 7.8359 9.75 8.25 9.75H9.75V8.25C9.75 7.8359 10.0859 7.5 10.5 7.5C10.9141 7.5 11.25 7.8359 11.25 8.25V9.75H12.75C13.1641 9.75 13.5 10.0859 13.5 10.5C13.5 10.9141 13.1641 11.25 12.75 11.25Z"
          fill="currentColor"
        />
        <path
          d="M2.74909 12.4048C2.38389 12.4048 2.06359 12.1372 2.00789 11.7652L1.0304 5.18462C0.923001 4.45752 1.1046 3.7325 1.5411 3.1421C1.9786 2.5523 2.62019 2.16802 3.34679 2.06062L10.2697 1.03133C11.3927 0.863826 12.4797 1.39121 13.05 2.37361C13.258 2.73201 13.1359 3.191 12.7775 3.399C12.4211 3.6065 11.9611 3.48491 11.7531 3.12651C11.4943 2.67871 10.9992 2.44002 10.4904 2.51472L3.5666 3.54402C3.2365 3.59282 2.94549 3.76762 2.74729 4.03572C2.54809 4.30382 2.4651 4.6334 2.5149 4.9644L3.49239 11.5445C3.55289 11.9542 3.2697 12.336 2.8606 12.3966C2.8235 12.4025 2.78619 12.4048 2.74909 12.4048Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default DuplicatePlus;
